/**
 *
 * FlashCardDetail
 *
 */

import { mapState, mapMutations } from 'vuex';

import FlashCardAnswerBtn from '@/views/FlashCard/FlashCardDetail/components/FlashCardFooter/FlashCardAnswerBtn.vue';

export default {
  name: 'FlashCardFooter',

  components: {
    FlashCardAnswerBtn,
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_isShowAnswer: 'isShowAnswer',
    }),
  },

  methods: {
    ...mapMutations('FlashCard/FlashCardDetail', {
      mm_SET_IS_SHOW_ANSWER: 'SET_IS_SHOW_ANSWER',
    }),

    showAnswer() {
      this.mm_SET_IS_SHOW_ANSWER(true);
    },

    answerFlashCard(answer) {
      this.$emit('answer-flash-card', answer);
    },
  },
};
